import React from 'react';
import { FeatureExplanationTopicBlock } from '@models/feature-explanation';

export const TopicExplanationBlock: React.FC<
  FeatureExplanationTopicBlock
> = block => <span className="topic">{block.name}</span>;
